import { services } from '../services';
var action = "report/price-version";

export const saleStageService = {
    getSaleStage,
    getSaleStageAll
};



function getSaleStage(param = '', uri='') {
    return services.restApi(`${action}${uri}${param}`, 'GET');
}
function getSaleStageAll(param = '', uri='/all') {
    return services.restApi(`${action}${uri}${param}`, 'GET');
}